import { User } from '@wizeoo/akm-message-lib';
import { ChronocodeVO } from '../vo/core/chronocode.vo';
import { FreeDataVO } from '../vo/core/freedata.vo';
import { WeightGridVO } from '../vo/integration/weightgrid.vo';
import { FormatVO } from '../vo/workingdata/format.vo';
import { MeasureVO } from '../vo/workingdata/measure.vo';
import { WeightGridEngine } from '../manager/workingdata/wg.engine';
import { MeasureEngine } from '../manager/workingdata/measure.engine';
import { FreedataEngine } from '../manager/core/freedata.engine';
import { LocaleEngine } from '../manager/locale/locale.engine';
import { FormatEngine } from '../manager/workingdata/format.engine';
import { ChronocodeEngine } from '../manager/core/chronocode.engine';
import { DataEngine } from '../manager/baselines/data.engine';
import { CellMatrixEngine } from '../manager/computer/cell-matrix.engine';
import { VisionEngine } from '../manager/vision/vision.engine';
import { VisionVO } from '../vo/vision/vision.vo';
import { DataLoadObj } from '../vo/workingdata/dataload-obj';
import { ScenarioVO } from '../vo/scenarii/scenario.vo';
import { ScenarioEngine } from '../manager/scenarii/scenario.engine';
import { LoadDataService } from '../manager/workingdata/load-data.service';
import { WorkComVO } from '../vo/workflow/workcom.vo';
import { WorkflowEngine } from '../manager/workflow/workflow.engine';
import { MatrixVO } from '../vo/matrix/matrix.vo';
import { MatrixEngine } from '../manager/matrix/matrix.engine';

/**
 * conteneur de données METIER (données, PAS objets uniques d'IHM NI méthodes statiques)
 * Même s'il existe des managers, les données nécessaires pour réaliser un calcul DOIVENT se trouver ici
 * Les managers ne font que des traitements. Ici est la vérité
 */
export class Model {

    public origin: string = 'compute';

    constructor() {
        // console.log("build allkeyComputeModel", this);
        this.localeEngine = new LocaleEngine(this);
        this.weightGridEngine = new WeightGridEngine(this);
        this.measureEngine = new MeasureEngine(this);
        this.freedataEngine = new FreedataEngine(this);
        this.formatEngine = new FormatEngine(this);
        this.chronocodeEngine = new ChronocodeEngine(this);
        this.dataEngine = new DataEngine(this);
        this.cellMatrixEngine = new CellMatrixEngine();
        this.visionEngine = new VisionEngine(this);
        this.scenarioEngine = new ScenarioEngine(this);
        this.loadDataService = new LoadDataService(this);
        this.workflowEngine = new WorkflowEngine(this);
        this.matrixEngine = new MatrixEngine(this);
    }


    /*****************************************************
     * les instances d'engine propres à CE modèle
     *****************************************************/
    // gestion des traductions
    protected _localeEngine: LocaleEngine = null;
    public get localeEngine(): LocaleEngine {
        return this._localeEngine;
    }
    public set localeEngine(value: LocaleEngine) {
        this._localeEngine = value;
    }

    // gestion des grilles de poids
    protected _weightGridEngine: WeightGridEngine = null;
    public get weightGridEngine(): WeightGridEngine {
        return this._weightGridEngine;
    }
    public set weightGridEngine(value: WeightGridEngine) {
        this._weightGridEngine = value;
    }

    // gestion des mesures
    protected _measureEngine: MeasureEngine = null;
    public get measureEngine(): MeasureEngine {
        return this._measureEngine;
    }
    public set measureEngine(value: MeasureEngine) {
        this._measureEngine = value;
    }
    // gestion des FD / FDVs
    protected _freedataEngine: FreedataEngine = null;
    public get freedataEngine(): FreedataEngine {
        return this._freedataEngine;
    }
    public set freedataEngine(value: FreedataEngine) {
        this._freedataEngine = value;
    }
    // gestion des formats
    protected _formatEngine: FormatEngine = null;
    public get formatEngine(): FormatEngine {
        return this._formatEngine;
    }
    public set formatEngine(value: FormatEngine) {
        this._formatEngine = value;
    }

    // gestion des chronocodes
    protected _chronocodeEngine: ChronocodeEngine = null;
    public get chronocodeEngine(): ChronocodeEngine {
        return this._chronocodeEngine;
    }
    public set chronocodeEngine(value: ChronocodeEngine) {
        this._chronocodeEngine = value;
    }

    // gestion des visions
    protected _visionEngine: VisionEngine = null;
    public get visionEngine(): VisionEngine {
        return this._visionEngine;
    }
    public set visionEngine(value: VisionEngine) {
        this._visionEngine = value;
    }

    // gestion des scenarios
    protected _scenarioEngine: ScenarioEngine = null;
    public get scenarioEngine(): ScenarioEngine {
        return this._scenarioEngine;
    }
    public set scenarioEngine(value: ScenarioEngine) {
        this._scenarioEngine = value;
    }

    // gestion des workflows
    protected _workflowEngine: WorkflowEngine = null;
    public get workflowEngine(): WorkflowEngine {
        return this._workflowEngine;
    }
    public set workflowEngine(value: WorkflowEngine) {
        this._workflowEngine = value;
    }

    protected _matrixEngine: MatrixEngine = null;
    public get matrixEngine(): MatrixEngine {
        return this._matrixEngine as MatrixEngine;
    }
    public set matrixEngine(value: MatrixEngine)  {
        this._matrixEngine = value;
    }

    /*****************************************************
     * les éléments de calcul alimenté par buildCompute
     *****************************************************/
    /* le gestionnaire de données */
    protected _dataEngine: DataEngine = null;
    public get dataEngine(): DataEngine {
        return this._dataEngine;
    }
    public set dataEngine(value: DataEngine) {
        this._dataEngine = value;
    }

    /* Le gestionnaire de cellules */
    private _cellMatrixEngine: CellMatrixEngine = null;
    public get cellMatrixEngine(): CellMatrixEngine {
        return this._cellMatrixEngine;
    }
    public set cellMatrixEngine(value: CellMatrixEngine) {
        this._cellMatrixEngine = value;
    }

    protected _loadDataService: LoadDataService = null;
    public get loadDataService(): LoadDataService {
        return this._loadDataService;
    }
    public set loadDataService(value: LoadDataService) {
        this._loadDataService = value;
    }

    /***************************
     * Clés d'unicité
     ***************************/
    /** l'utilisateur connecté, valable uniquement depuis l'IHM, alimenté lors de la connection */
    private _currentUser: User = null;
    public get currentUser(): User {
        return this._currentUser;
    }
    public set currentUser(value: User) {
        this._currentUser = value;
    }

    /** map de clés (code#level = [code FDV]) posées sur l'utilisateur */
    public userTagMap: Map<string, Set<string>> = null;


    // le code du domaine
    private _domainCode: string = null;
    public get domainCode(): string {
        return this._domainCode;
    }
    public set domainCode(value: string) {
        this._domainCode = value;
    }
    // le code de la bu
    private _businessUnitCode: string = null;
    public get businessUnitCode(): string {
        return this._businessUnitCode;
    }
    public set businessUnitCode(value: string) {
        this._businessUnitCode = value;
    }

    /***************************
     * Données à la BU
     ***************************/
    // la langue en cours (celle du user))
    private _currentLocaleCode: string = null;
    public get currentLocaleCode(): string {
        return this._currentLocaleCode;
    }
    public set currentLocaleCode(value: string) {
        this._currentLocaleCode = value;
    }
    // la locale par défaut de la BU
    private _buLocaleCode: string = null;
    public get buLocaleCode(): string {
        return this._buLocaleCode;
    }
    public set buLocaleCode(value: string) {
        this._buLocaleCode = value;
    }
    // le code de la vision en cours de calcul
    private _visionCode: string = null;
    public get visionCode(): string {
        return this._visionCode;
    }
    public set visionCode(value: string) {
        this._visionCode = value;
    }

    /***************************
     * WeightGrids
     ***************************/
    // dico de wg map[code] = wgVO
    private _weightGridMap: Map<string, WeightGridVO> = null;
    public get weightGridMap(): Map<string, WeightGridVO> {
        return this._weightGridMap;
    }
    public set weightGridMap(value: Map<string, WeightGridVO>) {
        this._weightGridMap = value;
    }
    // code-wg = MeasureVO encapsulation des wgs comme des mesures pour gestion dans la vue mesures. Alimenté sur chargement des wgs
    private _weightAsMeasureMap: Map<string, MeasureVO> = null;
    public get weightAsMeasureMap(): Map<string, MeasureVO> {
        return this._weightAsMeasureMap;
    }
    public set weightAsMeasureMap(value: Map<string, MeasureVO>) {
        this._weightAsMeasureMap = value;
    }

    /***************************
     * Measures
     ***************************/
    /** Liste de mesures, brute, pour la vision en cours */
    private _measureList: MeasureVO[] = null;
    public get measureList(): MeasureVO[] {
        return this._measureList;
    }
    public set measureList(value: MeasureVO[]) {
        this._measureList = value;
    }
    // map des mesures vision => stepLevel(0 = vision) =>  shortCode = measureVO
    private _measureMap: Map<string, Map<number, Map<string, MeasureVO>>> = null;
    public get measureMap(): Map<string, Map<number, Map<string, MeasureVO>>> {
        return this._measureMap;
    }
    public set measureMap(value: Map<string, Map<number, Map<string, MeasureVO>>>) {
        this._measureMap = value;
    }

    /***************************
     * Freedatas
     ***************************/

    /** collection des freeDatas */
    private _freeDataCollection: FreeDataVO[];
    public get freeDataCollection(): FreeDataVO[] {
        return this._freeDataCollection;
    }
    public set freeDataCollection(value: FreeDataVO[]) {
        this._freeDataCollection = value;
    }
    /** Map des freedatas avec le code comme clé et le freedata comme valeur */
    private _freedataMap: Map<string, FreeDataVO>;
    public get freedataMap(): Map<string, FreeDataVO> {
        return this._freedataMap;
    }
    public set freedataMap(value: Map<string, FreeDataVO>) {
        this._freedataMap = value;
    }

    /***************************
     * Formats
     ***************************/
    // la liste brutes des formats
    private _formatList: FormatVO[] = null;
    public get formatList(): FormatVO[] {
        return this._formatList;
    }
    public set formatList(value: FormatVO[]) {
        this._formatList = value;
    }
    // map des formats: bu(*)  = code = FormatVO
    private _formatMap: Map<string, Map<string, FormatVO>> = null;
    public get formatMap(): Map<string, Map<string, FormatVO>> {
        return this._formatMap;
    }
    public set formatMap(value: Map<string, Map<string, FormatVO>>) {
        this._formatMap = value;
    }

    /***************************
     * Chronocodes
     ***************************/
    /** Liste de chronocodes, brute */
    private _chronocodeList: ChronocodeVO[] = null;
    public get chronocodeList(): ChronocodeVO[] {
        return this._chronocodeList;
    }
    public set chronocodeList(value: ChronocodeVO[]) {
        this._chronocodeList = value;
    }
    /** Map de chronocode  key = code */
    private _chronocodesMap: Map<string, ChronocodeVO> = null;
    public get chronocodesMap(): Map<string, ChronocodeVO> {
        return this._chronocodesMap;
    }
    public set chronocodesMap(value: Map<string, ChronocodeVO>) {
        this._chronocodesMap = value;
    }

    /***************************
     * Visions
     ***************************/
    // pool de visions
    protected _visions: VisionVO[] = null;
    public get visions(): VisionVO[] {
        return this._visions;
    }
    public set visions(value: VisionVO[]) {
        this._visions = value;
    }

    // dico de vision map[buCode] = map[code] = visionVO
    protected _visionsDic: Map<string, Map<string, VisionVO>>;
    public get visionsDic(): Map<string, Map<string, VisionVO>> {
        return this._visionsDic;
    }
    public set visionsDic(value: Map<string, Map<string, VisionVO>>) {
        this._visionsDic = value;
    }

    /** retourne la vision VO relative au triplet domain/bu/vision */
    public get currentVision(): VisionVO {
        const vivo: VisionVO = this.visionEngine.getVision(this.visionCode);
        return vivo;
    }

    /***************************
     * Scenarii
     ***************************/
    // la liste de scenarii
    protected _scenariiList: ScenarioVO[] = null;
    public get scenariiList(): ScenarioVO[] {
        return this._scenariiList;
    }
    public set scenariiList(value: ScenarioVO[]) {
        this._scenariiList = value;
    }

    // map des Scenarii: code vision  = code#level = Scenario
    protected _scenariiMap: Map<string, Map<string, ScenarioVO>> = null;
    public get scenariiMap(): Map<string, Map<string, ScenarioVO>> {
        return this._scenariiMap;
    }
    public set scenariiMap(value: Map<string, Map<string, ScenarioVO>>) {
        this._scenariiMap = value;
    }

    /******************************************************
     * mémorisation des éléments de travail
     ******************************************************/
    // chargement des données :  map par vision / level / scenar = dlo
    public dataMap: Map<string, Map<number, Map<string, DataLoadObj>>> = new Map();


    /******************************************************
     * mémorisation des workflows
     ******************************************************/
    public workcomList: WorkComVO[] = null;
    // map des messages: NaturalID  = WorkComVO
    public workcomMap: Map<string, WorkComVO> = null; 
    // map des messages: vision  = clé parent  = WorkComVO[]
    // public workcomByParentMap: Map<string, Map<string, WorkComVO[]>> = null; 

    // liste des matrices
    public matrixList: MatrixVO[] = null;
    // map des matrices: bu  = code = MatrixVO
    public matrixMap: Map<string, Map<string, MatrixVO>> = null;


}
